// Characteristic groups shown in the quote builder and maintenance catalog.
export const CHAR_GROUPS = [
  { key: "general", label: "General" },
  { key: "contraplacado", label: "Contraplacado" },
  { key: "relleno", label: "Relleno" },
  { key: "marco", label: "Marco" },
  { key: "otros", label: "Otros" },
];

export const CHAR_GROUP_KEYS = CHAR_GROUPS.map((g) => g.key);

export const groupOf = (item) =>
  CHAR_GROUP_KEYS.includes(item?.group) ? item.group : "general";

export const groupLabel = (key) =>
  (CHAR_GROUPS.find((g) => g.key === key) || CHAR_GROUPS[0]).label;
